import { useEffect, useRef, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { telegram } from '../../api/fee'
import { nav } from '../../lib/checkout'
import { describeError } from '../../api/errorMessages'

/**
 * Port of `TelegramConnectionCheckComponent` (`/connections/telegram/check`):
 * the Telegram Login Widget redirects here with the signed login data as
 * query parameters; every parameter except `state` is sent to
 * `PATCH /connections/telegram/connect {telegramData}` (the backend verifies
 * Telegram's hash), then back to `/connections/telegram`. A refused
 * connection (`{"error": …}` with HTTP 200) is shown, not swallowed.
 */
export function TelegramConnectionCheckPage() {
  const [params] = useSearchParams()
  const started = useRef(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (started.current) return
    started.current = true
    const data: Record<string, string> = {}
    params.forEach((value, key) => {
      if (key !== 'state') data[key] = value
    })
    telegram
      .connect(data)
      .then(() => nav.assign('/connections/telegram'))
      .catch((err: unknown) => setError(describeError(err, 'Connecting Telegram failed')))
  }, [params])

  return (
    <div className="portal-card portal-card--notice">
      <h1>Connecting Telegram …</h1>
      {error && (
        <>
          <p role="alert" className="portal-notice portal-notice--error">
            {error}
          </p>
          <Link to="/connections/telegram">Back to Telegram connection</Link>
        </>
      )}
    </div>
  )
}
